import SmoothScroll from "smooth-scroll";
import "../../widgets/appel_offres/_appel";
let font_actual = 100;
const displayHeader = () => {
	let the_menu = document.getElementById("full-menu");
	let header = document.getElementById("header");
	header.classList.toggle("opened");
	if (the_menu) {
		the_menu.classList.toggle("open");
	}
};

(function ($) {
	$(window).on("elementor/frontend/init", function () {
		function initMap($el) {
			var $markers = $el.find(".marker");
			var mapArgs = {
				zoom: $el.data("zoom") || 11,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
			};
			var map = new google.maps.Map($el[0], mapArgs);
			map.markers = [];
			$markers.each(function () {
				initMarker($(this), map);
			});

			centerMap(map);
			return map;
		}
		function initMarker($marker, map) {
			var lat = $marker.data("lat");
			var lng = $marker.data("lng");
			var latLng = {
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			};

			var marker = new google.maps.Marker({
				position: latLng,
				map: map,
				animation: google.maps.Animation.DROP,
				icon: "https://f-ms.fr/wp-content/plugins/lezardscreation/assets/img/pin.png",
			});

			marker.addListener("click", () => {
				let titre = document.getElementById("mapinfobox-title");
				let adresse = document.getElementById("mapinfobox-adresse");
				let mail = document.getElementById("mapinfobox-mail");
				let tel = document.getElementById("mapinfobox-tel");
				let infobox = document.getElementById("mapinfobox");
				let lien = document.getElementById("mapinfobox-lien");
				infobox.classList.add("visible");
				titre.innerHTML = $marker[0].dataset.name;
				adresse.innerHTML = $marker[0].dataset.adresse;
				mail.innerHTML = $marker[0].dataset.mail;
				tel.innerHTML = $marker[0].dataset.telephone;
				if ($marker[0].dataset.lien) {
					lien.href = $marker[0].dataset.lien;
				}
			});

			map.markers.push(marker);
		}
		function centerMap(map) {
			var bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function (marker) {
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng(),
				});
			});
			if (map.markers.length == 1) {
				map.setCenter(bounds.getCenter());
			} else {
				map.fitBounds(bounds);
			}
		}

		$(".acf-map").each(function () {
			var map = initMap($(this));
			setTimeout(() => {
				$(".affichage-map").hide(0);
			}, 2000);
		});
		$("#show_etablissement_liste").click(function () {
			$(this).addClass("current");
			$("#show_etablissement_carte").removeClass("current");
			$(".affichage-liste").show(0);
			$(".affichage-map").hide(0);
		});
		$("#show_etablissement_carte").click(function () {
			$("#show_etablissement_liste").removeClass("current");
			$(this).addClass("current");
			$(".affichage-liste").hide(0);
			$(".affichage-map").show(0);
		});
		$("body").on("click", "#show_formulaire_en_ligne", function () {
			$("#formulairebenevole").css({ display: "block" });
		});
	});
})(jQuery);

const manageFontSize = () => {
	let moinsgros = document.querySelector("#moinsgros");
	let retour_ala_normal = document.querySelector("#taillenormale");
	let plusgros = document.querySelector("#plusgros");

	moinsgros.addEventListener("click", () => {
		font_actual -= 10;
		document.body.style.zoom = font_actual + "%";
	});

	plusgros.addEventListener("click", () => {
		font_actual += 10;
		document.body.style.zoom = font_actual + "%";
	});

	retour_ala_normal.addEventListener("click", () => {
		font_actual = 100;
		document.body.style.zoom = "100%";
	});
};

window.addEventListener("DOMContentLoaded", () => {
	manageFontSize();

	if ("speechSynthesis" in window) {
		window.speechSynthesis.cancel();
	}

	var scroll = new SmoothScroll('a[href*="#"]', {
		speed: 800,
		easing: "easeInOutCubic",
	});

	AOS.init({
		mirror: false,
		once: true,
		duration: 700,
		easing: "ease-in-out",
		anchorPlacement: "bottom-bottom",
	});

	let sector_selector = document.getElementById("sector_selector");
	let accordeons = document.querySelectorAll(".custom_accordeon .part");
	let toggle_accordeon = document.querySelectorAll(".custom_accordeon .tool");
	let header = document.getElementById("header");
	let showmenu = document.getElementById("showmenu");
	let showmenu2 = document.getElementById("showmenu2");
	let voicerecognitions = document.querySelectorAll(".voice-recognition");
	let liseuse = document.getElementById("voiceover");
	let contrast_switcher = document.getElementById("contrast");
	let change_blog_theme = document.getElementById("blog_theme");
	let change_blog_year = document.getElementById("blog_date");
	let change_contrat = document.getElementById("change_contrat");
	let change_etablissement = document.getElementById("change_etablissement");
	let filtres_services_archives = document.querySelectorAll(".archive_services .main-rubrique span");
	let filtres_services_archives_active = document.querySelector(".archive_services .main-rubrique span.active");
	let listes_services_archives = document.querySelectorAll(".archive_services .affichage-liste a.fiche");
	let letternavigator = document.getElementById("letternavigator");
	let recherche_etablissement = document.getElementById("etablissement-search");
	let recherche_prestation = document.getElementById("prestation-search");
	let mots = document.querySelectorAll(".le-lexique .mot .showmorelexique");
	let msnry;
	let lexique_module_mot = document.querySelectorAll(".lexique .mot .title");
	let close_popup = document.querySelector("#mapinfobox .close");

	if (sector_selector) {
		sector_selector.addEventListener("change", (e) => {
			window.location.href = e.target.value;
		});
	}

	if (close_popup) {
		close_popup.addEventListener("click", () => {
			document.querySelector("#mapinfobox").classList.remove("visible");
		});
	}

	if (lexique_module_mot) {
		lexique_module_mot.forEach((el) => {
			el.addEventListener("click", () => {
				el.parentNode.classList.toggle("visible");
			});
		});
	}

	if (mots) {
		mots.forEach((el) => {
			el.addEventListener("click", () => {
				el.parentNode.parentNode.classList.toggle("reveal");
				msnry.reloadItems();
				msnry.layout();
			});
		});
	}

	if (letternavigator) {
		let blocs = document.querySelectorAll(".newbloc");
		let recherche = document.getElementById("motrecherche");
		let first = true;
		msnry = new Masonry(".mots", {
			itemSelector: ".mot",
		});

		blocs.forEach((item) => {
			var el = document.createElement("div");
			el.setAttribute("data-block", item.getAttribute("id"));
			el.innerText = item.dataset.letter;
			el.classList.add("letter");
			letternavigator.appendChild(el);
			el.addEventListener("click", () => {
				let allel = document.querySelectorAll("#letternavigator .letter");
				let cible = el.dataset.block;
				let allblocks = document.querySelectorAll(".newbloc");

				// Je masque tout
				allblocks.forEach((arg2) => {
					arg2.classList.remove("visible");
				});
				allel.forEach((arg) => {
					arg.classList.remove("current");
				});

				// J'affiche tout
				el.classList.add("current");
				document.getElementById(cible).classList.add("visible");

				// Refresh Masonry
				msnry.reloadItems();
				msnry.layout();

				// Je clique sur le premier élément
			});
			if (first) {
				el.click();
				first = !first;
			}
		});
		recherche.addEventListener("keyup", (e) => {
			if (e.target.value[0]) {
				let letters = document.querySelectorAll("#letternavigator .letter");
				letters.forEach((el) => {
					if (el.dataset.block === "letter" + e.target.value[0].toUpperCase()) {
						el.click();
						console.log("je click");
					}
				});
			}
		});
	}

	if (filtres_services_archives) {
		filtres_services_archives.forEach((item) => {
			item.addEventListener("click", () => {
				let target = item.dataset.target;
				filtres_services_archives.forEach((el) => {
					el.classList.remove("active");
				});
				item.classList.add("active");
				listes_services_archives.forEach((el) => {
					if (el.classList.contains(target)) {
						el.classList.remove("masked");
					} else {
						el.classList.add("masked");
					}
				});
				aos.refresh();
			});
		});
		if (filtres_services_archives_active) {
			filtres_services_archives_active.click();
		}
	}
	let filtres_etablissements_archives = document.querySelectorAll(".listes-etablissements .main-rubrique");
	let filtres2_etablissements_archives = document.querySelectorAll(".listes-etablissements .main-rubrique span");
	let listes_etablissements_archives = document.querySelectorAll(".listes-etablissements .affichage-liste a.fiche");
	if (toggle_accordeon) {
		toggle_accordeon.forEach((item) => {
			item.addEventListener("click", () => {
				if (item.innerHTML === "Afficher +") {
					accordeons.forEach((el) => {
						el.classList.add("opened");
					});
					item.innerHTML = "Afficher -";
				} else {
					accordeons.forEach((el) => {
						el.classList.remove("opened");
					});
					item.innerHTML = "Afficher +";
				}
			});
		});
	}
	if (accordeons) {
		accordeons.forEach((item) => {
			item.querySelector(".content").style.display = "none";
			item.querySelector(".barre").addEventListener("click", () => {
				if (item.classList.contains("opened")) {
					item.classList.remove("opened");
				} else {
					item.classList.add("opened");
				}
			});
		});
		if (accordeons[0]) {
			accordeons[0].querySelector(".barre").click();
		}
	}
	if (filtres_etablissements_archives) {
		filtres_etablissements_archives.forEach((item) => {
			item.addEventListener("click", () => {
				if (item.classList.contains("all")) {
					listes_etablissements_archives.forEach((el) => {
						el.classList.remove("masked");
					});
					aos.refresh();
				}
				filtres_etablissements_archives.forEach((el) => {
					el.classList.remove("active");
				});
				item.classList.add("active");
			});
		});
		filtres2_etablissements_archives.forEach((item) => {
			item.addEventListener("click", () => {
				let target = item.dataset.target;
				filtres2_etablissements_archives.forEach((el) => {
					el.classList.remove("active");
				});
				item.classList.add("active");
				listes_etablissements_archives.forEach((el) => {
					if (el.classList.contains(target)) {
						el.classList.remove("masked");
					} else {
						el.classList.add("masked");
					}
				});
				aos.refresh();
			});
		});
	}
	if (change_etablissement) {
		change_contrat.addEventListener("change", (e) => {
			let jobs = document.querySelectorAll(".liste-jobs .job");
			jobs.forEach((item) => {
				if (item.classList.contains(change_contrat.value) && item.classList.contains(change_etablissement.value)) {
					item.classList.remove("masked");
				} else {
					item.classList.add("masked");
				}
			});
			aos.refresh();
		});

		change_etablissement.addEventListener("change", (e) => {
			let jobs = document.querySelectorAll(".liste-jobs .job");
			jobs.forEach((item) => {
				if (item.classList.contains(change_contrat.value) && item.classList.contains(change_etablissement.value)) {
					item.classList.remove("masked");
				} else {
					item.classList.add("masked");
				}
			});
			aos.refresh();
		});
	}
	if (change_blog_year) {
		change_blog_year.addEventListener("change", (e) => {
			let articles = document.querySelectorAll("#blog .post");
			articles.forEach((item) => {
				if (item.classList.contains(change_blog_theme.value) && item.classList.contains(change_blog_year.value)) {
					item.classList.remove("masked");
					aos.refresh();
				} else {
					item.classList.add("masked");
					aos.refresh();
				}
			});
		});
	}
	if (change_blog_theme) {
		if (change_blog_year) {
			change_blog_theme.addEventListener("change", (e) => {
				let articles = document.querySelectorAll("#blog .post");
				articles.forEach((item) => {
					if (item.classList.contains(change_blog_theme.value) && item.classList.contains(change_blog_year.value)) {
						item.classList.remove("masked");
						aos.refresh();
					} else {
						item.classList.add("masked");
						aos.refresh();
					}
				});
			});
		} else {
			change_blog_theme.addEventListener("change", (e) => {
				let articles = document.querySelectorAll("#blog .post");
				articles.forEach((item) => {
					if (item.classList.contains(change_blog_theme.value)) {
						item.classList.remove("masked");
						aos.refresh();
					} else {
						item.classList.add("masked");
						aos.refresh();
					}
				});
			});
		}
	}

	showmenu.addEventListener("click", () => {
		displayHeader();
	});
	showmenu2.addEventListener("click", () => {
		displayHeader();
	});
	voicerecognitions.forEach((el) => {
		el.addEventListener("click", () => {
			if (window.hasOwnProperty("webkitSpeechRecognition")) {
				if (window.speechSynthesis.speaking) {
					window.speechSynthesis.cancel();
					return;
				}
				var recognition = new webkitSpeechRecognition();
				recognition.continuous = false;
				recognition.interimResults = false;
				recognition.lang = "fr-FR";
				recognition.start();
				el.classList.add("listening");
				recognition.onresult = function (e) {
					el.previousSibling.value = e.results[0][0].transcript;
					recognition.stop();
					el.classList.remove("listening");
					setTimeout(() => {
						el.parentNode.parentNode.submit();
					}, 1000);
				};
				recognition.onerror = function (e) {
					recognition.stop();
					console.log("error");
					el.classList.remove("listening");
				};
				recognition.onnomatch = function (e) {
					console.log("not match");
					el.classList.remove("listening");
				};
			}
		});
	});
	liseuse.addEventListener("click", () => {
		if ("speechSynthesis" in window) {
			if (window.speechSynthesis.speaking) {
				window.speechSynthesis.cancel();
				return;
			}
			var synthesis = window.speechSynthesis;
			// Get the first `en` language voice in the list
			var voices = window.speechSynthesis.getVoices();
			let voice_final;
			voices.forEach((voice) => {
				if (voice.lang == "fr-FR") {
					voice_final = voice;
				}
			});
			var element_to_read = document.querySelector("#textealire").textContent.trim();
			var utterance = new SpeechSynthesisUtterance(element_to_read);
			// Set utterance properties
			utterance.pitch = 0.9;
			utterance.voice = voice_final;
			utterance.rate = 1.0;
			utterance.lang = "fr-FR";
			utterance.volume = 1.0;
			window.speechSynthesis.speak(utterance);
		} else {
			console.log("Text-to-speech not supported.");
		}
	});
	contrast_switcher.addEventListener("click", () => {
		if (document.body.classList.contains("contrast")) {
			document.body.classList.remove("contrast");
		} else {
			document.body.classList.add("contrast");
		}
	});

	if (recherche_etablissement) {
		recherche_etablissement.addEventListener("keyup", (e) => {
			if (e.target.value.length >= 2) {
				let fiches = document.querySelectorAll(".fiche");
				fiches.forEach((item) => {
					let titre3 = item.querySelector("h3");
					if (
						titre3.innerHTML
							.toString()
							.toLowerCase()
							.normalize("NFD")
							.replace(/[\u0300-\u036f]/g, "")
							.replace(/'/g, "")
							.replace("’", "")
							.includes(
								e.target.value
									.toString()
									.toLowerCase()
									.normalize("NFD")
									.replace(/[\u0300-\u036f]/g, "")
									.replace(/'/g, "")
									.replace("’", "")
							)
					) {
						item.classList.remove("hidden");
					} else {
						item.classList.add("hidden");
					}
				});
			} else {
				let fiches = document.querySelectorAll(".fiche");
				fiches.forEach((item) => {
					item.classList.remove("hidden");
				});
			}
		});
	}
	if (recherche_prestation) {
		recherche_prestation.addEventListener("keyup", (e) => {
			console.log(e.target.value);
			if (e.target.value.length >= 2) {
				let fiches = document.querySelectorAll(".fiche");
				fiches.forEach((item) => {
					let titre3 = item.querySelector("h3");
					if (
						titre3.innerHTML
							.toString()
							.toLowerCase()
							.normalize("NFD")
							.replace(/[\u0300-\u036f]/g, "")
							.includes(
								e.target.value
									.toString()
									.toLowerCase()
									.normalize("NFD")
									.replace(/[\u0300-\u036f]/g, "")
							)
					) {
						item.classList.remove("hidden");
					} else {
						item.classList.add("hidden");
					}
				});
			} else {
				let fiches = document.querySelectorAll(".fiche");
				fiches.forEach((item) => {
					item.classList.remove("hidden");
				});
			}
		});
	}

	if (document.querySelector(".job")) {
		let jobs = document.querySelectorAll(".job .show_full");
		jobs.forEach((el) => {
			el.addEventListener("click", (e) => {
				el.parentNode.parentNode.classList.add("full");
			});
		});
	}
});
